import { z } from "zod";

import {
  audienceProfileSnapshotToPromptFacts,
  type AudienceProfileSnapshotV1,
} from "./audience-profile.ts";

export const effectiveAudienceContextV1Schema = z.object({
  version: z.literal(1),
  source: z.enum(["brief_override", "selected_audience_profile", "legacy_brand_facts", "none"]),
  sourceId: z.string().max(160).nullable(),
  label: z.string().max(500).nullable(),
  facts: z.record(z.string(), z.unknown()).nullable(),
});
export type EffectiveAudienceContextV1 = z.infer<typeof effectiveAudienceContextV1Schema>;

export const resolveEffectiveAudienceContext = (input: {
  explicitAudience?: string | null;
  explicitAudienceSourceId?: string | null;
  selectedAudienceProfile?: AudienceProfileSnapshotV1 | null;
  legacyAudienceFacts?: Record<string, unknown> | null;
  legacyAudienceSourceId?: string | null;
}): EffectiveAudienceContextV1 => {
  const explicitAudience = input.explicitAudience?.trim();
  if (explicitAudience) {
    return {
      version: 1,
      source: "brief_override",
      sourceId: input.explicitAudienceSourceId ?? null,
      label: explicitAudience,
      facts: { summary: explicitAudience },
    };
  }
  if (input.selectedAudienceProfile) {
    return {
      version: 1,
      source: "selected_audience_profile",
      sourceId: input.selectedAudienceProfile.id,
      label: input.selectedAudienceProfile.name,
      facts: audienceProfileSnapshotToPromptFacts(input.selectedAudienceProfile),
    };
  }
  if (input.legacyAudienceFacts && Object.keys(input.legacyAudienceFacts).length > 0) {
    return {
      version: 1,
      source: "legacy_brand_facts",
      sourceId: input.legacyAudienceSourceId ?? null,
      label: null,
      facts: input.legacyAudienceFacts,
    };
  }
  return { version: 1, source: "none", sourceId: null, label: null, facts: null };
};
